
import {
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import SelecionarModeloDocumentoFiscal from '@/components/Compartilhados/SelecionarModeloDocumentoFiscal.vue';
import { IDTOInutilizacaoNumeracao } from '@/models/DTO/Fiscal/IDTOInutilizacaoNumeracao';
import ServicoFaturamento from '@/servicos/Fiscal/ServicoFaturamento';

export default defineComponent({
  name: 'InutilizacaoNumeracaoModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icone,
    RequisicaoModal,
    SelecionarModeloDocumentoFiscal,
  },
  emits: ['update:visivel', 'confirmacao'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemSucesso } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso,
      ocultarBarraProgresso,
    } = useModalBase(props, emit);
    const servicoFaturamento = new ServicoFaturamento();
    servicoFaturamento.requisicaoSistema();
    telaBase.identificadorRecurso = 'NOTAS_FISCAIS';
    telaBase.identificadorPermissao = 'AUT_NOTAS_FISCAIS';

    const state = reactive({
      inutilizacao: {} as IDTOInutilizacaoNumeracao,
    });

    function limparTela() {
      state.inutilizacao = {} as IDTOInutilizacaoNumeracao;
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      apresentarBarraProgresso();
      state.inutilizacao.empresa = props.empresa;
      retorno = await servicoFaturamento.inutilizarNumeracao(state.inutilizacao);
      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso('Faixa de numeração inutilizada com sucesso!');
        emit('confirmacao');
        modalBase.computedVisivel = false;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparTela();
      // if (modalBase.computedVisivel) {}
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      telaBase,
      modalBase,
      salvar,
    };
  },
});
